import * as React from 'react'
import { Field, InjectedFormProps, reduxForm , reset} from 'redux-form'
import { useDispatch, useSelector } from 'react-redux'
import { Card, CardBody } from 'reactstrap'
import { RouteComponentProps } from 'react-router'

import { updatePassword } from './index.reducer'
import { translate } from '../../i18n'
import Button from '../../../Web/common/Button/Button.web'
import ContentWrapper from '../../../Web/common/contentWrapper.web'
import { required } from '../../../Web/common/validate'
import { FormField } from '../../../Web/components/FormField/FormField'
import { showErrorMessage } from '../../utils'
import { IAppState } from '../../store/state.interface.web'

// todo: saga success&data from api

const ChangePasswordForm: React.FC<
  InjectedFormProps<{}, RouteComponentProps> & RouteComponentProps
> = props => {
  const { handleSubmit } = props
  const dispatch = useDispatch()

  const loading = useSelector<IAppState, boolean>((state: IAppState) => state.changePassword.loading)

  // *custom methods
  const submitChangePassword = (submittedValues: any) => {
    if (submittedValues.password !== submittedValues.confirmPassword) {
      return showErrorMessage('Password does not match')
    }
    dispatch(updatePassword(submittedValues))
  }
  const backButtonHandler = () => {
    props.history.push('/')
  }

  return (
    <ContentWrapper>
      <div className="content-heading">
        <div>{translate('changePassword.title')}</div>
      </div>
      <Card className="card-default">
        <CardBody>
          <div className="content">
            <div className="section is-fullheight">
              <div className="column col-lg-6 is-4 is-offset-4">
                <div className="box">
                  <form autoComplete="off" onSubmit={handleSubmit(submitChangePassword)}>
                    <Field
                      label={translate('changePassword.oldPasswordLabel')}
                      name="oldPassword"
                      component={FormField}
                      validate={[required]}
                      required
                      type="password"
                      placeholder={translate(
                        'changePassword.oldPasswordPlaceholder'
                      )}
                    />
                    <Field
                      label={translate('changePassword.newPasswordLabel')}
                      name="password"
                      component={FormField}
                      validate={[required]}
                      required
                      type="password"
                      placeholder={translate(
                        'changePassword.newPasswordPlaceholder'
                      )}
                    />
                    <Field
                      label={translate('changePassword.confirmPasswordLabel')}
                      name="confirmPassword"
                      component={FormField}
                      required
                      validate={[required]}
                      type="password"
                      placeholder={translate(
                        'changePassword.confirmPasswordPlaceholder'
                      )}
                    />
                    <div className="d-flex my-3">
                      <Button
                        type="button"
                        color="secondary"
                        onClick={backButtonHandler}
                        btnText={translate('common.back')}
                      />
                      <Button
                        loading={loading}
                        type="submit"
                        btnText={translate('common.change')}
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
    </ContentWrapper>
  )
}

export default reduxForm<{}, RouteComponentProps>({
  form: 'ChangePasswordForm'
})(ChangePasswordForm)
